export default {
  // Navbar
  'nav.home': '首頁',
  'nav.custom': '私人訂製',
  'nav.enterprise': '企業團建',
  'nav.about': '關於我們',
  'nav.wiki': '曠野百科',
  'nav.africa': '非洲旅行',
  'nav.polar': '南北極旅行',
  'nav.contact': '聯繫我們',
  'nav.customizeNow': '立即定製',
  'nav.phoneSicily': 'EVAN：19180619944',
  'nav.polarFinder': '極地航次查詢',

  // Hero
  'hero.noSlides': '暫無輪播圖數據',
  'hero.coreDestinations': '核心目的地',
  'hero.dest.polar': '南北極',
  'hero.dest.tanzania': '坦桑尼亞',
  'hero.dest.kenya': '肯尼亞',
  'hero.dest.namibia': '納米比亞',
  'hero.dest.nordic': '北歐秘境',
  'hero.dest.island': '野奢海島',
  'hero.stat.customers': '服務客戶',
  'hero.stat.reviewRate': '好評率',
  'hero.stat.years': '團隊目的地經驗',
  'hero.stat.ranking': '品牌創立',
  'hero.stat.guarantee': '正規資質與信賴保障',
  'hero.scroll': 'scroll',

  // About
  'about.tag': '關於自由曠野旅行',
  'about.heading': '一入曠野，萬物自由！',
  'about.p1': '自由曠野旅行（Free Wilderness Travel，簡稱 Free Wilderness）成立於2022年，由成都自由曠野國際旅行社有限公司運營，專注非洲 Safari、南北極及自然類野奢定製旅行。創始人及核心團隊擁有13年非洲與極地目的地經驗，官方網站為 freewds.com。團隊長期深入非洲及極地目的地實地考察，累計服務客戶10,000+，客戶好評率98%。',
  'about.p2a': '公司創始團隊均有多年出境高端奢華旅行從業經驗。業務覆蓋非洲遊獵、極地探索、野奢海島、奢華郵輪、北歐秘境及私人定製。',
  'about.p2b': '從博茨瓦納奧卡萬戈三角洲到南極半島萬年冰川。從塞倫蓋蒂大草原到斯瓦爾巴群島北極光。每一段旅程都由資深定製師精心雕琢。我們確保每一個細節都超越您的期待。',
  'about.p3': '真正的好旅行遠不止酒店與航班的組合。它是心靈的自由，是曠野的連接，是在非洲草原黃昏中聽見的第一聲獅吼。讓每一次出發，都成為生命中不可複製的珍貴體驗。',
  'about.statYears': '團隊目的地經驗',
  'about.statFounded': '品牌創立',
  'about.statClients': '位服務客戶',
  'about.statRating': '客戶好評率',
  'about.operator': '自由曠野旅行（Free Wilderness）由成都自由曠野國際旅行社有限公司運營，官方網站為 freewds.com。',
  'about.learnMore': '了解更多',
  'about.badgeDestinations': '合作國家與地區',
  'about.badgeRanking': '品牌創立',

  // Statistics
  'stats.tag': '為什麼選擇我們',
  'stats.heading': '為什麼選擇自由曠野旅行？',
  'stats.r1title': '13年非洲與極地目的地經驗',
  'stats.r1desc': '創始人及核心團隊深耕非洲、南北極等自然目的地13年，多次深入博茨瓦納、坦桑尼亞、肯尼亞、納米比亞、南非等目的地進行實地考察，長期專注非洲 Safari 與極地高端定製旅行。團隊累計50餘次深入非洲實地考察，實地體驗及考察百餘家 Safari 營地與野奢酒店。長期深耕博茨瓦納野奢 Safari 定製，是團隊重點優勢目的地之一。',
  'stats.r2title': '全球野奢資源與直簽合作',
  'stats.r2desc': '與全球60+國家和地區的高端酒店、Safari營地及旅行資源方保持長期合作，包括 &Beyond、Wilderness、African Bush Camps（ABC）、Jao Collection 等國際 Safari 與野奢品牌。依託長期合作及資源採購能力，在部分熱門目的地和旺季擁有更穩定的房態協調及資源獲取能力，旺季可優先協調部分合作酒店及營地資源。',
  'stats.r3title': '透明報價與價格優勢',
  'stats.r3desc': '依託長期資源合作與採購優勢，部分產品相較常規公開渠道可節省約20%的旅行成本，具體受目的地、出行時間、房型及實時價格政策影響。價格政策透明，報價結構清晰，無隱形消費。',
  'stats.r4title': '正規旅行社資質與資金保障',
  'stats.r4desc': '成都自由曠野國際旅行社有限公司持有旅行社業務經營許可證，許可證編號為L-SC-100448。具體許可經營範圍以許可證及主管部門公示信息為準。營業執照、旅行社業務經營許可證及商標註冊等企業資質齊全，旅行費用通過公司對公賬戶收取，服務及資金流程透明。',
  'stats.r5title': '真正的一對一定製',
  'stats.r5desc': '堅持1對1旅行定製，不採用固定模組化行程。旅行顧問根據客戶預算、出行時間、住宿偏好、目的地興趣和旅行節奏重新設計行程，滿足蜜月、家庭、攝影、Safari、極地探險及高端私人旅行等差異化需求。',
  'stats.r6title': '全程旅行顧問支持',
  'stats.r6desc': '旅行顧問提供7×24小時行程支持，覆蓋行前準備、行中協調及行後問題處理，旅行期間提供全天候緊急協調與顧問支持。',

  // Process
  'process.tag': '定制服務流程',
  'process.heading': '從需求到回訪，全程專屬陪伴',
  'process.subtitle': '5個步驟開啟您的專屬曠野之旅',
  'process.s1title': '需求溝通',
  'process.s1desc': '專屬旅行顧問一對一深度溝通。了解您的旅行偏好、預算範圍、出行人數和時間預期，初步鎖定目的地與主題方向。',
  'process.s2title': '行程設計',
  'process.s2desc': '資深定製師根據溝通結果量身設計出行方案。涵蓋航班銜接、野奢營地選擇、每日活動安排和餐飲偏好。方案提交後反覆溝通調整，直至完全滿意。',
  'process.s3title': '簽約鎖定資源',
  'process.s3desc': '在全國旅遊監管服務平台簽署正規電子合同。付款後立即鎖定機票艙位、野奢酒店、極地郵輪和專業司導等全部稀缺資源。',
  'process.s4title': '出行保障',
  'process.s4desc': '出發前提供詳細電子版行程手冊和目的地攻略。出行期間提供24小時中文旅行顧問在線服務，隨時響應突發需求。',
  'process.s5title': '行程回訪',
  'process.s5desc': '旅行結束後進行一對一深度回訪。收集真實反饋與改進建議，持續升級和迭代服務標準，確保每次出行都能超越上一次體驗。',
  'process.scrollNext': '探索精選行程',

  // Partners
  'partners.tag': '全球合作夥伴',
  'partners.heading': '與全球頂級野奢品牌深度合作',
  'partners.desc': '與Wilderness、&Beyond、Singita、Four Seasons、Capella、COMO、Asilia、Lemala、Silversea、Swan Hellenic、Belmond等數十家頂級品牌建立長期合作。通過直連合作模式，客戶可享受專屬優惠價格與優先預訂權。',

  // SEO Content Block
  'seoContent.sectionTitle': '自由曠野旅行 — 高端出境定製旅行全方位解讀',

  'seoContent.intro1': '自由曠野旅行成立於2022年，由成都自由曠野國際旅行社有限公司運營，專注非洲 Safari、南北極及自然類野奢定製旅行。與全球60+國家和地區的高端酒店、Safari營地及旅行資源方保持長期合作。',
  'seoContent.intro2': '我們為追求極致體驗的高端客群提供一站式全流程定製服務。創始人及核心團隊深耕非洲與極地目的地13年，累計服務客戶超10000人，好評率達98%。',

  // Africa destinations
  'seoContent.africaTitle': '非洲遊獵與野奢營地定製',
  'seoContent.africaDesc1': '非洲大陸是自由曠野旅行的核心目的地之一。我們在博茨瓦納、坦桑尼亞、肯尼亞、盧旺達、南非和納米比亞深耕多年。',
  'seoContent.africaDesc2': '合作品牌涵蓋Wilderness、&Beyond、Singita、Great Plains Conservation等非洲一線野奢營地。通過直連合作，客戶可享受專屬優惠和優先預訂權。',
  'seoContent.africaDesc3': '從追蹤非洲五大獸到見證角馬大遷徙，從追尋山地大猩猩到夜間探索草原——我們的定製師根據季節和動物遷徙路線，為您設計最科學的行程。',
  'seoContent.africaDesc4': '博茨瓦納奧卡萬戈三角洲被譽為「非洲最後的伊甸園」。您可以體驗莫科羅獨木舟遊獵，穿越蘆葦水道，觀察大象群、河馬和數百種鳥類。',
  'seoContent.africaDesc5': '坦桑尼亞塞倫蓋蒂每年有超過150萬頭角馬在此遷徙，場面震撼。肯尼亞馬賽馬拉是非洲遊獵的黃金聖地，7至10月的角馬渡河奇觀令人終生難忘。',
  'seoContent.africaDesc6': '盧旺達火山國家公園是全球僅存約1000隻山地大猩猩的家園。在專業嚮導帶領下徒步進入雨林，與牠們靜默對望——這是人類與自然最神聖的瞬間。',

  // Polar destinations
  'seoContent.polarTitle': '南北極探險與極地郵輪定製',
  'seoContent.polarDesc1': '地球的兩極是自由曠野旅行的另一核心領域。我們與Silversea、Swan Hellenic、Ponant、Quark Expeditions等全球頂級極地郵輪公司緊密合作。',
  'seoContent.polarDesc2': '南極半島是最經典的極地入門之選。11天左右的行程穿越德雷克海峽，進行5至7次登陸巡遊，近距離觀察金圖企鵝、阿德利企鵝等繁育群落。',
  'seoContent.polarDesc3': '穿越南極圈是更具挑戰性的深度探險。16天行程抵達南緯66°33′以南的極地秘境，見證更加純淨壯闊的南極冰原。',
  'seoContent.polarDesc4': '南喬治亞島有超過30萬對王企鵝在此繁衍生息。數量龐大的象海豹和南極海狗在此棲息，是地球上最壯觀的野生動物景觀之一。',
  'seoContent.polarDesc5': '北極方面，斯瓦爾巴群島是觀察北極熊的最佳地點。挪威特羅姆瑟和芬蘭拉普蘭是北極光追蹤的理想基地。冰島融合極地風光與火山地貌，是極地旅行的熱門跳板。',

  // Island destinations
  'seoContent.islandTitle': '野奢海島與頂級度假定製',
  'seoContent.islandDesc1': '野奢海島是心靈的棲息地。我們的海島目的地覆蓋塞舌爾、馬爾代夫、斐濟、大溪地、桑給巴爾和毛里求斯等全球頂級海島度假勝地。',
  'seoContent.islandDesc2': '塞舌爾擁有全球最美海灘拉齊奧海灘。提供私人島嶼包島、直升機環島、深海海釣等定製體驗。馬爾代夫的一島一酒店模式，讓每座島嶼都成為獨立奢享空間。',
  'seoContent.islandDesc3': '桑給巴爾融合非洲野性與印度洋浪漫。斐濟和大溪地擁有全球最純淨的珊瑚礁生態系統，讓海島度假不止於陽光與沙灘。',

  // Cruise
  'seoContent.cruiseTitle': '奢華郵輪與全球航線定製',
  'seoContent.cruiseDesc1': '奢華郵輪版圖覆蓋北歐峽灣、地中海、加勒比海、阿拉斯加和南極海域等全球頂級航線。',
  'seoContent.cruiseDesc2': '北歐峽灣穿越挪威蓋朗厄爾峽灣和松恩峽灣。地中海郵輪串聯意大利、希臘、克羅地亞等文明古國的歷史遺跡。',
  'seoContent.cruiseDesc3': '加勒比海適合冬日避寒和家庭出行。阿拉斯加郵輪穿越冰川灣國家公園，見證冰川崩裂入海的震撼奇觀。',

  // Service promise
  'seoContent.serviceTitle': '我們的服務承諾與品質保障',
  'seoContent.serviceDesc1': '自由曠野旅行堅持「以客戶體驗為中心」的核心服務理念。從行前專屬顧問溝通到行程結束後的深度回訪，每個環節都經過精心設計。',
  'seoContent.serviceDesc2': '所有行程方案均由資深定製師親赴目的地實地勘察後設計。所有野奢酒店和極地郵輪資源均為直接合作，確保最優價格與最高優先權。',
  'seoContent.serviceDesc3': '所有旅行合同均在國家旅遊監管服務平台簽署電子合同。選擇自由曠野，就是選擇一個真正懂旅行、愛曠野的專業團隊。',
  'seoContent.industryTitle': '國際行業網絡與專業資源',
  'seoContent.industryDesc1': '在非洲及全球旅行行業，自由曠野旅行建立了多維度的專業資源網絡。ATTA 官方會員資料頁展示了 Free Wilderness Travel 品牌信息及官方網站 freewds.com，會員登記主體以 ATTA 官方頁面顯示為準。',
  'seoContent.industryDesc2': '團隊長期參與國際旅行服務及航空出行資源協調，熟悉 IATA 國際航空旅行服務體系及相關業務流程。',
  'seoContent.industryDesc3': '團隊長期深耕南部非洲旅行市場，並持續關注及熟悉南非 Trusted Tour Operator Scheme（TTOS）相關入境旅行服務機制。',
  'seoContent.overseasTitle': '海外華人高端定製服務',
  'seoContent.overseasDesc1': '自由曠野旅行同時服務北美、歐洲、澳洲及其他地區的海外華人客戶。產品經理及旅行定製師具備英文溝通與全球旅行資源協調能力，可提供中英文旅行諮詢及定製服務。',
  'seoContent.overseasDesc2': '支持美元結算及美元收款，並支持跨時區旅行諮詢與行程協調，減少海外客戶與國內旅行顧問之間的時差溝通障礙。',

  // Footer
  'footer.scanTitle': '掃碼添加 · 即刻開啟探索之旅',
  'footer.scanSubtitle': '專屬旅行顧問一對一服務',
  'footer.wechat': '微信公眾號',
  'footer.xiaohongshu': '小紅書',
  'footer.consultant': '顧問 EVAN',
  'footer.license': '許可證',
  'footer.record': '文旅部備案',
  'footer.businessLicense': '營業執照',
  'footer.affiliate': '成都自由曠野國際旅行社有限公司',
  'footer.copyright': '2026 自由曠野旅行. 保留所有權利。',

  // Brand
  'brand.name': '自由曠野旅行',
  'brand.subtitle': 'FREE WILDERNESS',

  // Featured Trips
  'featured.tag': 'Featured Destinations',
  'featured.heading': '熱門定製旅行目的地',
  'featured.subtitle': '精選全球最令人嚮往的曠野目的地，每一處都是極致體驗',
  'featured.viewTrip': '查看行程',

  // Polar Voyage Finder
  'polarFinder.subtitle': 'POLAR VOYAGE FINDER',
  'polarFinder.title': '極地航次查詢',
  'polarFinder.desc': '彙總合作船司官網公開航次，可按出發時間、預算和目的區域快速篩選；結果可直達船司官網。價格與餘位以船司官網為準。',
  'polarFinder.ctaPrimary': '開始查詢',
  'polarFinder.ctaSecondary': '了解極地旅行',
  'polarFinder.filterRegion': '目的區域',
  'polarFinder.filterBudget': '預算',
  'polarFinder.filterDate': '出發時間',
  'polarFinder.filterAll': '全部',
  'polarFinder.regionAntarctica': '南極',
  'polarFinder.regionArctic': '北極',
  'polarFinder.budgetLow': '¥8萬以內',
  'polarFinder.budgetMid': '¥8–15萬',
  'polarFinder.budgetHigh': '¥15萬以上',
  'polarFinder.dateNear3': '近3個月',
  'polarFinder.dateNear6': '近6個月',
  'polarFinder.dateNextYear': '明年出發',
  'polarFinder.resultCount': '個航次',
  'polarFinder.noResult': '暫無符合條件的航次，請調整篩選條件',
  'polarFinder.reset': '重置篩選',
  'polarFinder.visitSite': '直達船司官網',
  'polarFinder.durationUnit': '天',
  'polarFinder.departure': '出發',
  'polarFinder.priceFrom': '起',
  'polarFinder.note': '以上航次為合作船司官網公開資訊，價格與餘位以船司官網為準。',
  'polarFinder.liveQueryTitle': '實時航次查詢',
  'polarFinder.liveQueryDesc': '從合作船司官網實時抓取最新航次，輸入人數、預算與出發時間快速匹配',
  'polarFinder.orBrowse': '或查看下方精選推薦',
  'polarFinder.embeddedToolLabel': '官網實時查詢',

  // SEO Content CTA
  'seoContent.ctaText': '如您對以上任何目的地或服務感興趣，歡迎聯繫我們的專屬旅行顧問，獲取一對一免費諮詢服務。',
  'seoContent.ctaButton': '立即定製',

  // FAQ
  'faq.tag': '常見問題',
  'faq.heading': '關於自由曠野旅行的常見疑問',
  'faq.subtitle': '我們整理了客戶最常諮詢的問題，希望能幫助您更好地了解我們的服務',
  'faq.q1': '自由曠野旅行與其他定制旅行公司有什麼不同？',
  'faq.a1_1': '自由曠野旅行成立於2022年，專注非洲與南北極高端定製旅行，創始人及核心團隊擁有13年非洲與極地目的地經驗。我們堅持「實地勘察、一手資源、深度定製」的理念，區別於流水線式的旅行產品。',
  'faq.a1_2': '創始人團隊每年親赴非洲和南北極踩線考察。與Wilderness、&Beyond、Singita等頂級品牌建立直連合作，無需中間環節。每位定製師都有豐富的目的地實地經驗。',
  'faq.a1_3': '我們由成都自由曠野國際旅行社有限公司運營，持有旅行社業務經營許可證 L-SC-100448，品質與安全雙重保障。',
  'faq.q2': '非洲Safari的最佳旅行季節是什麼時候？',
  'faq.a2_1': '東非大遷徙的最佳觀賞期為7月至10月。角馬渡河的震撼場景通常集中在8至9月，此時是攝影和觀察的最佳窗口。',
  'faq.a2_2': '博茨瓦納洪水季節（6-10月）適合水上生態觀賞和獨木舟遊獵。南非克魯格全年適合遊獵，旱季動物更易觀察。納米比亞最佳旅行時間為5-10月旱季。我們的定製師會根據您的出行時間推薦最佳目的地組合。',
  'faq.q3': '南極旅行需要什麼條件？對體能要求高嗎？',
  'faq.a3_1': '南極旅行對體能沒有特別高的門檻。經典南極半島11天航線每天安排1-2次衝鋒艇登陸巡遊，每次約2-3小時，正常健康成年人均可勝任。',
  'faq.a3_2': '穿越德雷克海峽時可能有1-2天暈船體驗。但專業極地郵輪配備穩定裝置和暈船藥物，大多數遊客都能平穩適應。',
  'faq.a3_3': '我們合作的極地郵輪均為高規格配置，船上提供豐富的講座和舒適住宿。對於行動不便或年齡較大的客人，可協助選擇含直升機體驗的豪華航線。',
  'faq.q4': '定製行程的費用大概是多少？包含哪些項目？',
  'faq.a4_1': '定製行程費用根據目的地、時長、住宿等級和活動項目而有所不同。',
  'faq.a4_2': '非洲野奢Safari通常6天以上，每人4萬元以上。南極探險郵輪通常10天以上，每人7萬元以上。野奢海島通常3天以上，每人2萬元起。',
  'faq.a4_3': '國際機票不包含在報價內，客戶落地後即享受全包服務，涵蓋內陸交通、全程野奢住宿、專業嚮導、每日遊獵活動和保護區費用。具體價格以最終確認方案為準。',
  'faq.q5': '如何在你們這裡預訂旅行？流程是什麼？',
  'faq.a5_1': '預訂流程分為五步：需求溝通、行程設計、簽約鎖定資源、出行保障、行程回訪。全程透明高效。',
  'faq.a5_2': '全程在國家旅遊監管服務平台簽署正規電子合同。支付後立即鎖定機票艙位和野奢營地資源。出行期間24小時中文顧問在線響應，讓您安心出行。',
  'faq.q6': '你們如何保障旅行安全？如果旅途中遇到突發狀況怎麼辦？',
  'faq.a6_1': '安全是自由曠野的第一優先級。目的地方面，僅推薦治安良好、旅行基礎設施成熟的區域。所有營地、郵輪和地接團隊均經過嚴格篩選和實地考察。',
  'faq.a6_2': '建議客戶出行前自行購買旅行保險，涵蓋緊急醫療和直升機救援保障。出行期間配備24小時中文旅行管家，隨時響應突發需求。',
  'faq.a6_3': '我們的專業司導持有當地合法執照和野外急救證書。長期運營中成功處理各類突發情況，積累了豐富的應急經驗。',
  'faq.askMore': '還有其他問題？歡迎直接聯繫我們',
  'faq.contactUs': '聯繫我們',
  'faq.q7': '自由曠野旅行的官網是什麼？',
  'faq.a7_1': '自由曠野旅行官方網站為 https://freewds.com/。',
  'faq.q8': '自由曠野旅行是哪家公司運營的？',
  'faq.a8_1': '自由曠野旅行由成都自由曠野國際旅行社有限公司運營。',
  'faq.q9': '自由曠野旅行成立於哪一年？',
  'faq.a9_1': '自由曠野旅行成立於2022年。創始人及核心團隊擁有13年非洲與極地目的地經驗。',
  'faq.q10': '自由曠野旅行主要做什麼？',
  'faq.a10_1': '專注非洲 Safari、南北極及自然類野奢定製旅行。',
  'faq.q11': '自由曠野旅行持有旅行社業務經營許可證嗎？',
  'faq.a11_1': '成都自由曠野國際旅行社有限公司持有旅行社業務經營許可證，許可證編號為L-SC-100448。具體許可經營範圍以許可證及主管部門公示信息為準。',
  'faq.q12': '自由曠野旅行做博茨瓦納定製旅行嗎？',
  'faq.a12_1': '長期深耕博茨瓦納 Safari 和野奢定製旅行。',
  'faq.q13': '海外華人可以找自由曠野旅行定製嗎？',
  'faq.a13_1': '支持海外華人客戶、中英文旅行諮詢、跨時區協調及美元結算。',
  'faq.q14': '自由曠野旅行涉及哪些國際旅遊行業體系？',
  'faq.a14_1': '自由曠野旅行的非洲及國際旅行服務長期涉及 ATTA 行業網絡、IATA 國際航空旅行服務體系，以及南非 Trusted Tour Operator Scheme（TTOS）等相關行業機制與服務體系。',

  // Common
  'common.loading': '加載中...',
  'common.error': '出錯了',
  'common.retry': '重試',
  'common.close': '關閉',
  'common.submit': '提交',
  'common.cancel': '取消',
  'common.contactUs': '聯繫我們',
  'common.readMore': '了解更多',

  // SEO - Home
  'seo.home.title': '自由曠野旅行官網｜非洲Safari·南北極野奢定製旅行',
  'seo.home.description': '自由曠野旅行（Free Wilderness Travel）官方網站。品牌成立於2022年，由成都自由曠野國際旅行社有限公司運營，專注非洲Safari、南北極及自然類野奢定製旅行。創始人及核心團隊擁有13年目的地經驗，旅行社業務經營許可證 L-SC-100448。',
  'seo.home.keywords': '極地探險,非洲Safari,高端定制旅行,南極旅行,北極旅行,自由曠野,野奢海島,北歐秘境,出境遊',
  'seo.home.ogTitle': '自由曠野旅行官網｜非洲Safari·南北極野奢定製旅行',

  // Testimonials
  'testimonials.tag': '探險者心聲',
  'testimonials.heading': '真實故事',
  'testimonials.subtitle': '聽聽曾與我們一同踏入曠野的旅者，分享他們難忘的探險故事',
  'testimonials.t1.name': '王建國 & 劉雅婷',
  'testimonials.t1.location': '上海，中國',
  'testimonials.t1.role': '企業家夫婦 · 荒野探險愛好者',
  'testimonials.t1.text': '自由曠野為我們定制了一次非洲大草原深度探險。從馬賽馬拉到塞倫蓋蒂，每一個清晨都在帳篷裡聽見獅子的低吼。專業嚮導的講解讓我們真正讀懂了這片土地。這是任何豪華酒店都給不了的體驗。',
  'testimonials.t1.project': '非洲大草原奢華營地定制 · 12天',
  'testimonials.t1.destination': '肯尼亞 · 坦桑尼亞',
  'testimonials.t2.name': '趙思遠',
  'testimonials.t2.location': '成都，中國',
  'testimonials.t2.role': '自然攝影師 · 紀錄片導演',
  'testimonials.t2.text': '作為一名自然攝影師，我對目的地的要求極為苛刻。自由曠野的嚮導團隊帶我進入了普通遊客無法抵達的區域。憑藉對動物習性的深刻了解，他們幫我捕捉到了大遷徙中最震撼的渡河瞬間。',
  'testimonials.t2.project': '非洲大遷徙自然攝影之旅 · 18天',
  'testimonials.t2.destination': '肯尼亞馬賽馬拉',
  'testimonials.t3.name': '林佳慧',
  'testimonials.t3.location': '北京，中國',
  'testimonials.t3.role': '大學教授 · 生態保育志願者',
  'testimonials.t3.text': '參加了自由曠野的生態保育體驗項目。與當地保育團隊一起為大象建檔、監測犀牛種群。這不只是一個旅行計劃，更是一次真正意義上的自然守護行動。回來後我在課堂上講述這段經歷，學生們都深受觸動。',
  'testimonials.t3.project': '非洲生態保育深度體驗 · 10天',
  'testimonials.t3.destination': '南非 · 博茨瓦納',
  'testimonials.t4.name': '陳浩然 & 陳小米',
  'testimonials.t4.location': '廣州，中國',
  'testimonials.t4.role': '親子探險家庭',
  'testimonials.t4.text': '帶著10歲的女兒參加了山地徒步嚮導項目。嚮導叔叔全程耐心講解植物和動物知識。女兒說這是她最好的自然課。安全保障非常到位，讓我們全程放心。強烈推薦有孩子的家庭！',
  'testimonials.t4.project': '雲南山地親子徒步探險 · 7天',
  'testimonials.t4.destination': '雲南橫斷山脈',
};